import Logo from '@/components/Logo';
import style from './Support.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@ax/ui';
import { usePasscodeSession } from '@/hooks/usePasscodeSession.tsx';
import useAnalytics from '@/hooks/useAnalytics.tsx';
import { LoginStage, routerPaths } from '@ax/constants';
import { loginStageChanged, useAppDispatch } from '@ax/redux-store';

export default function SupportPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { clearSession, forcePasscodeReset, isSessionInitialized, session } = usePasscodeSession();
  const { onTapResetPIN } = useAnalytics();

  return (
    <div className={style.support__page__container}>
      <div className={style.support__form__container}>
        <div className={style.support__form__header}>
          <div
            style={{ display: 'none' }}
            className={style.support__form__header__company_logo}
          >
            <Logo type="primary" />
          </div>
          <div className={style.support__form__header__app_logo}>
            <Logo type="go" />
          </div>
        </div>
        <div className={style.support__form__body}>
          <Button
            variant={'primary'}
            onClick={() => navigate(routerPaths.forgotPassword)}
          >
            Reset Password
          </Button>
          {isSessionInitialized && session && (
            <Button
              variant={'primary'}
              onClick={() => {
                clearSession();
                onTapResetPIN();
                forcePasscodeReset();
                dispatch(loginStageChanged({ stage: LoginStage.Initialization }));
                navigate(routerPaths.login);
              }}
            >
              Reset PIN
            </Button>
          )}
          <span>
            Support Number
            <br />
            <br />
            (888) 304-0450
          </span>
        </div>
      </div>
      <div className={style.support__page__footer}>
        <Link
          to={'https://augmedix.com/terms-and-policies/#terms-of-use'}
          className={style.support__page__link}
          target="_blank"
        >
          Terms and Conditions
        </Link>
        <Link
          to={'https://augmedix.com/terms-and-policies/#terms-of-use'}
          className={style.support__page__link}
          target="_blank"
        >
          Privacy Policy
        </Link>
      </div>
    </div>
  );
}
